module.exports = __webpack_public_path__ + "static/media/qa.78909a6f.svg";